import { Link } from '@/i18n/routing';
import { Fragment } from 'react';
import { useMediaQuery } from 'react-responsive';

import styles from './Pagination.module.css';

export const Pagination = ({ totalPages, page }) => {
  const isDesktop = useMediaQuery({ query: '(min-width: 768px)' });

  const MAX_PAGES_VISIBLE = isDesktop ? 8 : 4;
  const prev = page - 1;
  const next = totalPages <= page ? 0 : page + 1;
  const isPaginationEnding = totalPages - page < MAX_PAGES_VISIBLE;

  return (
    <nav
      aria-label="Page navigation"
      className="tab-content flex flex-wrap gap-2 max-sm:px-4 items-center justify-end max-lg:pt-8 lg:pt-2"
    >
      {page !== 1 ? (
        <Link
          href={`/reviews/1`}
          rel="first"
          aria-label="First Page"
          className={styles.pagination_icon}
          prefetch={false}
        >
          <i className={`${styles.icon_size} icon-expand_left_stop`} />
        </Link>
      ) : (
        <i
          className={`${styles.icon_size} icon-expand_left_stop text-slate-200`}
        />
      )}
      {prev ? (
        <Link
          href={`/reviews/${prev}`}
          rel="prev"
          aria-label="Previous Page"
          className={styles.pagination_icon}
          prefetch={false}
        >
          <i className={`${styles.icon_size} icon-expand_left`} />
        </Link>
      ) : (
        <i className={`${styles.icon_size} icon-expand_left text-slate-200`} />
      )}
      {Array(Math.min(MAX_PAGES_VISIBLE, totalPages))
        .fill()
        .map((item, i) =>
          i + 1 === MAX_PAGES_VISIBLE && !isPaginationEnding ? (
            <Fragment key={i}>
              <div className="flex flex-col gap-1 min-w-0">
                <span className={styles.pagination_item}>...</span>
              </div>
              <div className="flex flex-col gap-1 min-w-0">
                <Link
                  href={`/reviews/${totalPages}`}
                  className={`${styles.pagination_item} ${styles.pagination_item_hover}`}
                  prefetch={false}
                >
                  {totalPages}
                </Link>
              </div>
            </Fragment>
          ) : (
            <div key={i} className="flex flex-col gap-1 min-w-0">
              {(
                isPaginationEnding
                  ? totalPages - MAX_PAGES_VISIBLE + 1 + i === page
                  : i === 0
              ) ? (
                <span
                  className={`${styles.pagination_item} !text-white !bg-primary-800 rounded-full`}
                >
                  {page}
                </span>
              ) : (
                <Link
                  href={`/reviews/${
                    isPaginationEnding
                      ? totalPages - MAX_PAGES_VISIBLE + 1 + i
                      : i + page
                  }`}
                  className={`${styles.pagination_item} ${styles.pagination_item_hover}`}
                  prefetch={false}
                >
                  {isPaginationEnding
                    ? totalPages - MAX_PAGES_VISIBLE + 1 + i
                    : i + page}
                </Link>
              )}
            </div>
          )
        )}
      {next ? (
        <Link
          href={`/reviews/${next}`}
          rel="next"
          aria-label="Next Page"
          className={styles.pagination_icon}
          prefetch={false}
        >
          <i className={`${styles.icon_size} icon-expand_right`} />
        </Link>
      ) : (
        <i className={`${styles.icon_size} icon-expand_right text-slate-200`} />
      )}
      {page !== totalPages ? (
        <Link
          href={`/reviews/${totalPages}`}
          rel="last"
          aria-label="Last Page"
          className={styles.pagination_icon}
          prefetch={false}
        >
          <i className={`${styles.icon_size} icon-expand_right_stop`} />
        </Link>
      ) : (
        <i
          className={`${styles.icon_size} icon-expand_right_stop text-slate-200`}
        />
      )}
    </nav>
  );
};
